// NOTE: See: https://docs.stripe.com/currencies#zero-decimal

export default function isZeroDecimalCurrency(currency: string): boolean {
  return [
    'bif',
    'clp',
    'djf',
    'gnf',
    'jpy',
    'kmf',
    'krw',
    'mga',
    'pyg',
    'rwf',
    'ugx',
    'vnd',
    'vuv',
    'xaf',
    'xof',
    'xpf',
  ].includes(currency)
}
